import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex w-full items-start gap-2" };
const _hoisted_2 = ["id"];
const _hoisted_3 = { class: "flex w-full flex-col gap-px" };
const _hoisted_4 = ["for"];
const _hoisted_5 = { class: "flex w-full items-center gap-2 rounded-xl border border-(--colors-border-base-medium) bg-(--colors-background-white) px-3 py-2" };
const _hoisted_6 = ["id", "aria-invalid", "aria-describedby", "onKeydown"];
const _hoisted_7 = ["aria-label"];
const _hoisted_8 = ["id"];
const _hoisted_9 = { class: "flex items-center justify-end gap-4" };
import { useId } from "vue";
import { Modal, Button, IconShape } from "@eudonet/opal";
import { useFilterNameField } from "@/shared/composables/useFilterNameField";
export default /*@__PURE__*/ _defineComponent({
    __name: 'RenameAdvancedFilterModal',
    props: {
        modelValue: { type: Boolean },
        currentName: {},
        busy: { type: Boolean, default: false },
        errorMessage: { default: null }
    },
    emits: ["update:modelValue", "rename"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const titleId = useId();
        const nameId = useId();
        const errorId = useId();
        const { name, shownError, validate } = useFilterNameField({
            isOpen: () => props.modelValue,
            initialName: () => props.currentName,
            errorMessage: () => props.errorMessage,
            requiredKey: "advancedFilterLibrary.rename.errors.nameRequired",
            tooLongKey: "advancedFilterLibrary.rename.errors.nameTooLong",
        });
        function onSubmit() {
            const trimmed = validate();
            if (trimmed)
                emit("rename", trimmed);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                "model-value": props.modelValue,
                size: "sm",
                "footer-position": "right",
                "aria-labelledby": _unref(titleId),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (emit('update:modelValue', $event)))
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(IconShape), {
                            size: "md",
                            type: "square",
                            variant: "outlined",
                            color: "white",
                            icon: "ri-pencil-line"
                        }),
                        _createElementVNode("h4", {
                            id: _unref(titleId),
                            class: "text-xl font-bold leading-6 text-(--colors-text-heading)"
                        }, _toDisplayString(_ctx.$t("advancedFilterLibrary.rename.title")), 9 /* TEXT, PROPS */, _hoisted_2)
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                        _createVNode(_unref(Button), {
                            variant: "secondary",
                            label: _ctx.$t('advancedFilterLibrary.rename.cancel'),
                            disabled: props.busy,
                            onClick: _cache[2] || (_cache[2] = ($event) => (emit('update:modelValue', false)))
                        }, null, 8 /* PROPS */, ["label", "disabled"]),
                        _createVNode(_unref(Button), {
                            "data-testid": "rename-filter-submit",
                            variant: "primary",
                            "icon-left": "ri-save-3-fill",
                            label: _ctx.$t('advancedFilterLibrary.rename.submit'),
                            loading: props.busy,
                            disabled: props.busy,
                            onClick: onSubmit
                        }, null, 8 /* PROPS */, ["label", "loading", "disabled"])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("label", {
                            for: _unref(nameId),
                            class: "px-px text-sm font-medium leading-5 text-(--colors-text-black-default)"
                        }, _toDisplayString(_ctx.$t("advancedFilterLibrary.rename.nameLabel")), 9 /* TEXT, PROPS */, _hoisted_4),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                id: _unref(nameId),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(name) ? (name).value = $event : null)),
                                "data-testid": "rename-filter-name",
                                type: "text",
                                "aria-invalid": !!_unref(shownError),
                                "aria-describedby": _unref(shownError) ? _unref(errorId) : undefined,
                                class: "min-w-0 flex-1 border-0 bg-transparent text-sm leading-5 text-(--colors-text-black-default) outline-none",
                                onKeydown: _withKeys(_withModifiers(onSubmit, ["prevent"]), ["enter"])
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                                [_vModelText, _unref(name)]
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                "data-testid": "rename-filter-clear",
                                "aria-label": _ctx.$t('advancedFilterLibrary.rename.clear'),
                                class: "shrink-0 text-(--colors-text-body-subtle)",
                                onClick: _cache[1] || (_cache[1] = ($event) => (name.value = ''))
                            }, [...(_cache[4] || (_cache[4] = [
                                    _createElementVNode("i", {
                                        class: "ri-close-line text-base",
                                        "aria-hidden": "true"
                                    }, null, -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_7)
                        ]),
                        (_unref(shownError))
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                id: _unref(errorId),
                                "data-testid": "rename-filter-name-error",
                                role: "alert",
                                class: "px-px pt-1 text-sm leading-5 text-(--text-text-error-strong)"
                            }, _toDisplayString(_unref(shownError)), 9 /* TEXT, PROPS */, _hoisted_8))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "aria-labelledby"]));
        };
    }
});
